module.exports = __webpack_public_path__ + "d1ce93df70cbe0daa2eeefdece8923ce.pdf";